import React, { Component } from 'react'
import { Field, reduxForm, change } from 'redux-form'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import cx from 'classnames'

// COMPONENTS
import Spinner from '../spinner'
import customInputLine from './field/customInputLine'
import maskInput from './field/maskInput'
import { ButtonContained } from '../app-button/button'
import {
  required,
  email,
  minLength,
  asyncValidate,
  phone,
} from './validation/validation'

const styles = theme => ({
  form: {
    maxWidth: 320,
    width: '100%',
  },
  invalid: {},
  '@keyframes wiggle': {
    '33%': { transform: 'rotateZ(1deg)' },
    to: { transform: 'rotateZ(-1deg)' },
  },

  wiggle: {
    willChange: 'transform',
    animationName: 'wiggle',
    animationDuration: '150ms',
    animationIterationCount: 4,
  },
})

class ChatApplicationForm extends Component {
  resetValueField = name => {
    this.props.change(this.props.form, name, '')
  }

  handleClick = (classes, submitFailed) => {
    if (submitFailed) {
      this.form.classList.remove(classes.wiggle)

      void this.form.offsetWidth

      this.form.classList.add(classes.wiggle)
    }
  }

  render() {
    const {
      classes,
      handleSubmit,
      isFetching,
      submitFailed,
      invalid,
    } = this.props

    return (
      <form
        onSubmit={handleSubmit}
        className={cx(
          classes.form,
          { [classes.wiggle]: submitFailed },
          { [classes.novalidate]: invalid }
        )}
        ref={form => (this.form = form)}
      >
        <div className={classes.inputWrapper}>
          <Field
            name="name"
            component={customInputLine}
            type="text"
            label="Название чата"
            validate={[required]}
            // handleResetField={this.resetValueField}
          />
        </div>
        <div className={classes.inputWrapper}>
          <Field
            // ref={ref => (this.field = ref)}
            name="description"
            component={customInputLine}
            type="text"
            label="Комментарий"
            // validate={[required]}
            // handleResetField={this.resetValueField}
          />
        </div>
        <ButtonContained
          style={{
            height: 64,
            fontSize: 16,
            width: '100%',
            padding: 0,
            fontWeight: 600,
          }}
          type="submit"
          color="primary"
          onClick={() => this.handleClick(classes, submitFailed)}
          text={
            isFetching ? <Spinner stroke="#000000" /> : 'Подать заявку'
          }
        />
      </form>
    )
  }
}

const mapDispatchToProps = {
  change,
}

ChatApplicationForm = reduxForm({
  form: 'ChatApplicationForm',
})(
  connect(
    null,
    mapDispatchToProps
  )(ChatApplicationForm)
)

export default withStyles(styles)(ChatApplicationForm)
